export const retailViews = {
  impressions: 'estimated_impressions_digit',
  impressionsOverTime: 'estimated_impressions_time_series',
  trafficEstimatedImpressions: 'traffic_estimated_impressions',
  salesUplift: 'pos_sales_uplift'
};
